import { render, staticRenderFns } from "./ErrorForm.vue?vue&type=template&id=04746149&"
import script from "./ErrorForm.vue?vue&type=script&lang=js&"
export * from "./ErrorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports